import React from "react";
import * as XLSX from "xlsx";
import {
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Paper,
  TableContainer,
  Button,
  Grid,
  TablePagination,
  InputAdornment,
  TextField,
  Divider,
} from "@mui/material";

import ModeEditOutlinedIcon from "@mui/icons-material/ModeEditOutlined";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import PageContainer from "src/components/container/PageContainer";
import ParentCard from "src/components/shared/ParentCard";
import { useState, useEffect } from "react";
// import SubscriptionService from "src/service/vehicleCategory";
import SubscriptionService from "src/service/subscription";
import { useNavigate } from "react-router";
import swal from "sweetalert";
import { Link } from "react-router-dom";

import { IconFileDownload, IconPlus, IconSearch } from "@tabler/icons";
import Breadcrumb from "src/layouts/full/shared/breadcrumb/Breadcrumb";
import { writeFile } from "xlsx";

const BCrumb = [
  {
    to: "/",
    title: "Home",
  },
  {
    title: "Plan and Subscription",
  },
];

const PlanSubscriptionList = () => {
  // ====================================

  const navigate = useNavigate();

  const sessionData = JSON.parse(localStorage.getItem("user"));
  const [subscriptions, setSubscription] = useState([]);

  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [visibleData, setVisibleData] = useState([]);

  //  for table sorting
  const [sortOrder, setSortOrder] = useState("asc"); // 'asc' or 'desc'
  const [sortColumn, setSortColumn] = useState("plan_name"); // Initial column to sort

  const fetchSubscriptionData = async () => {
    try {
      const res = await SubscriptionService.getSubscription({});

      setSubscription(res.data);
      setVisibleData(res.data);
    } catch (error) {
      console.log(error);
    }
  };

  const deleteSubscription = async (id) => {
    swal({
      title: "Delete plan and subscription",
      text: "Are you sure you want to delete this plan and subscription?",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async (willDelete) => {
      if (willDelete) {
        try {
          const response = await SubscriptionService.deleteSubscription({
            id: id,
            d_by: sessionData.data.id,
          });
          if (response.status === 200) {
            swal("success", response.message, "success");

            fetchSubscriptionData();
          } else {
            swal("Error", response.message, "error");
          }
        } catch (error) {
          swal("Error", error, "error");
        }
      }
    });
  };

  useEffect(() => {
    fetchSubscriptionData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sessionData.data.id, sessionData.data.user_type]);

  const filteredPlans = subscriptions.filter((man) =>
    man.plan_name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  useEffect(() => {
    const startIndex = page * rowsPerPage;
    const endIndex = startIndex + rowsPerPage;
    const filteredData = subscriptions.filter((man) =>
      man.plan_name.toLowerCase().includes(searchTerm.toLowerCase())
    );
    const visibleData = filteredData.slice(startIndex, endIndex);
    setVisibleData(visibleData);
  }, [subscriptions, page, rowsPerPage, searchTerm]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleExport = () => {
    const headers = [
      "Sl. No",
      "Plan Name",
      "Plan Type",
      "Validity (Days)",
      "Charges (₹)",
    ];

    const data = visibleData.map((man, index) => [
      index + 1,
      man.plan_name,
      man.plan_type,
      man.validity,
      man.charge,
    ]);

    const exportData = [headers, ...data];

    const ws = XLSX.utils.aoa_to_sheet(exportData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet 1");

    const fileName = "subscription_data.xlsx";

    writeFile(wb, fileName);
  };

  // table column sorting start here
  const handleSort = (column) => {
    // Toggle sorting order if clicking on the same column
    if (sortColumn === column) {
      setSortOrder((prevSortOrder) =>
        prevSortOrder === "asc" ? "desc" : "asc"
      );
    } else {
      // Set new column to sort
      setSortColumn(column);
      // Default sorting order for the new column
      setSortOrder("asc");
    }
  };

  const sortedSubscription = filteredPlans.sort((a, b) => {
    const compareValueA = a[sortColumn];
    const compareValueB = b[sortColumn];

    // Customize the comparison based on data types or specific conditions
    if (sortOrder === "asc") {
      return compareValueA.localeCompare(compareValueB);
    } else {
      return compareValueB.localeCompare(compareValueA);
    }
  });

  // ====================================
  return (
    <PageContainer
      title="Plan and Subscription"
      description="this is Basic Table page"
    >
      {/* breadcrumb */}
      <Breadcrumb title="Plan and Subscription" items={BCrumb} />
      {/* end breadcrumb */}

      <ParentCard title="">
        <Grid container alignItems="center">
          <Grid
            item
            xs={4}
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              gap: 2,
              marginBottom: "15px;",
            }}
          >
            <Typography
              style={{
                fontSize: "22px",
                fontWeight: "bold",
                fontFamily: "Sans-Serif",
              }}
              variant="h2"
            >
              Plan and Subscription List
            </Typography>
          </Grid>

          <Grid
            item
            xs={8}
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 2,
              marginBottom: "15px;",
            }}
          >
            {sessionData.data.user_type === 1 && (
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  navigate("/addPlanAndSubscription");
                }}
              >
                <IconPlus width={20} />
              </Button>
            )}
            <Button variant="contained" color="success" onClick={handleExport}>
              <IconFileDownload width={20} />
            </Button>
          </Grid>
        </Grid>
        <Divider />
        <Grid container alignItems="center">
          <Grid
            item
            xs={12}
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 2,
              marginBottom: "20px;",
              marginTop: "20px;",
            }}
          >
            <TextField
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <IconSearch size="1.1rem" />
                  </InputAdornment>
                ),
              }}
              placeholder="search"
              size="small"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </Grid>
        </Grid>
        {/* </ParentCard> */}

        <Paper variant="outlined">
          <TableContainer>
            <Table
              aria-label="simple table"
              sx={{
                whiteSpace: "nowrap",
              }}
            >
              <TableHead style={{ backgroundColor: "#895c5c33" }}>
                <TableRow>
                  <TableCell style={{ textAlign: "center" }}>
                    <Typography style={{ fontSize: "15px" }} variant="h6">
                      Sl. No
                    </Typography>
                  </TableCell>

                  <TableCell
                    onClick={() => handleSort("plan_name")}
                    style={{ cursor: "pointer" }}
                  >
                    <Typography
                      style={{ fontSize: "15px", textAlign: "center" }}
                      variant="h6"
                    >
                      Plan Name
                      {/* Add arrow icon based on sorting order and column */}
                      {sortColumn === "plan_name" &&
                        (sortOrder === "asc" ? " ▲" : " ▼")}
                    </Typography>
                  </TableCell>

                  <TableCell>
                    <Typography style={{ fontSize: "15px" }} variant="h6">
                      Plan Type
                    </Typography>
                  </TableCell>

                  <TableCell>
                    <Typography style={{ fontSize: "15px" }} variant="h6">
                      Validity (Days)
                    </Typography>
                  </TableCell>

                  <TableCell>
                    <Typography style={{ fontSize: "15px" }} variant="h6">
                      Charges (₹)
                    </Typography>
                  </TableCell>

                  {sessionData.data.user_type === 1 && (
                    <TableCell>
                      <Typography style={{ fontSize: "15px" }} variant="h6">
                        Action
                      </Typography>
                    </TableCell>
                  )}
                </TableRow>
              </TableHead>
              <TableBody>
                {sortedSubscription.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={6} style={{ textAlign: "center" }}>
                      <Typography
                        style={{ fontSize: "13px" }}
                        variant="h6"
                        sx={{ color: "red" }}
                      >
                        No records found!!
                      </Typography>
                    </TableCell>
                  </TableRow>
                ) : (
                  sortedSubscription
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((man, index) => (
                      <TableRow key={man.id}>
                        <TableCell style={{ textAlign: "center" }}>
                          <Typography style={{ fontSize: "13px" }} variant="h6">
                            {index + 1}
                          </Typography>
                        </TableCell>

                        <TableCell style={{ textAlign: "center" }}>
                          <Typography style={{ fontSize: "13px" }} variant="h6">
                            {man.plan_name}
                          </Typography>
                        </TableCell>

                        <TableCell>
                          <Typography style={{ fontSize: "13px" }} variant="h6">
                            {man.plan_type === 1
                              ? "One Time"
                              : man.plan_type === 2
                              ? "Yearly"
                              : ""}
                          </Typography>
                        </TableCell>

                        <TableCell>
                          <Typography style={{ fontSize: "13px" }} variant="h6">
                            {man.validity}
                          </Typography>
                        </TableCell>

                        <TableCell>
                          <Typography style={{ fontSize: "13px" }} variant="h6">
                            {man.charge}
                          </Typography>
                        </TableCell>

                        {sessionData.data.user_type === 1 && (
                          <TableCell>
                            <Link to={`/updateSubscription/${man.id}`}>
                              <ModeEditOutlinedIcon
                                style={{
                                  color: "blue",
                                  fontSize: "18px",
                                  cursor: "pointer",
                                }}
                              />
                            </Link>

                            <DeleteOutlinedIcon
                              style={{
                                color: "red",
                                fontSize: "18px",
                                marginLeft: "10px",
                                cursor: "pointer",
                              }}
                              onClick={() => deleteSubscription(man.id)}
                            />
                          </TableCell>
                        )}
                      </TableRow>
                    ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
        <TablePagination
          rowsPerPageOptions={[10, 25, 50, 100, 500]}
          component="div"
          count={sortedSubscription.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </ParentCard>
    </PageContainer>
  );
};

export default PlanSubscriptionList;
